<wl-modal (closeModal)="closeModal()" [modalTitle]="content().modalTitle">
  <ng-template wlModalBody>
    <div class="d-flex flex-column gap-2">
      <p
        class="mb-0"
        *wlGenericRichText="{ value: content().modalContent }"
      ></p>
      <ul>
        @for (usp of usps(); track $index) {
          <li>
            {{ usp.text }}
            @if (usp.tooltip) {
              <wl-tooltip [tooltip]="{ description: usp.tooltip }"></wl-tooltip>
            }
          </li>
        }
      </ul>
      <p
        class="mb-0"
        *wlGenericRichText="{ value: content().modalContentBottom }"
      ></p>
      <crnt-button
        tabindex="0"
        variant="primary"
        wlAutomationId="accept-loyalty-product"
        (click)="primaryAction()"
      >
        {{ content().primaryButtonText }}
      </crnt-button>
      <crnt-button
        tabindex="0"
        variant="tertiary"
        wlAutomationId="reject-loyalty-product"
        (click)="secondaryAction()"
      >
        {{ content().secondaryButtonText }}
      </crnt-button>
    </div>
  </ng-template>
</wl-modal>
